<template>
        <button @click="greet"></button>
</template>
<script>
    export default {
        props: {
            functionName: {
                required: true,
                type: Function,
            },
        },

        methods: {
            greet() {
                alert('Hello worlds');
            }
        }
    }
</script>